<!--
Important note:
Use separate <img> elements for image and fallback image, because NgOptimizedImage
attributes cannot be updated.
Thus doing [ngSrc]="condition ? src() : fallbackSrc()" is not permitted.
-->

@if (!src() || (hasLoadError() && renderedFallbackSrc())) {
    @if (renderedFallbackSrc(); as renderedFallbackSrc) {
        <img
            hImageDestroyGuard
            [ngSrc]="renderedFallbackSrc"
            [loaderParams]="fallbackLoaderParams()"
            [width]="renderedDimensions()?.width"
            [height]="renderedDimensions()?.height"
            [fill]="!isFixedSize()"
            [sizes]="sizes()"
            [attr.alt]="alt()"
            [loading]="loading()"
            [priority]="priority()"
            [decoding]="decoding()"
            [style.object-fit]="fit() === 'fit' ? 'contain' : 'cover'" />
    }
} @else {
    <img
        hImageDestroyGuard
        [ngSrc]="src()"
        [loaderParams]="loaderParams()"
        [width]="renderedDimensions()?.width"
        [height]="renderedDimensions()?.height"
        [fill]="!isFixedSize()"
        [sizes]="sizes()"
        [attr.alt]="alt()"
        [loading]="loading()"
        [priority]="priority()"
        [decoding]="decoding()"
        [placeholder]="placeholder()"
        [style.object-fit]="fit() === 'fit' ? 'contain' : 'cover'"
        [class.broken]="hasLoadError()"
        (load)="imageLoaded.emit()"
        (error)="onLoadError()" />
}
